import { apiFetch } from '@/lib/api-client/client';

/** Matches the Worker's derived-permissions shape exactly (apps/worker/src/lib/permissions.ts). */
export interface GuildPermissions {
  administrator: boolean;
  manageGuild: boolean;
  manageRoles: boolean;
  manageChannels: boolean;
  manageMessages: boolean;
  manageNicknames: boolean;
  kickMembers: boolean;
  banMembers: boolean;
  moderateMembers: boolean;
}

export interface ManageableGuild {
  id: string;
  name: string;
  icon: string | null;
  owner: boolean;
  permissions: GuildPermissions;
  /**
   * Always null until the Bot Bridge exists (no code anywhere in this
   * repository can determine real bot membership yet — see the Batch 5
   * report). Never guessed as true/false.
   */
  botPresent: boolean | null;
}

export interface AuthUser {
  id: string;
  username: string;
  globalName: string | null;
  avatar: string | null;
}

export interface MeResponse {
  user: AuthUser;
  guilds: ManageableGuild[];
}

/** GET /api/auth/me — throws ApiError('UNAUTHENTICATED', ...) if not signed in; callers (AuthProvider) handle that, not this function. */
export function getMe(): Promise<MeResponse> {
  return apiFetch<MeResponse>('/api/auth/me');
}

export async function logout(): Promise<void> {
  await apiFetch<{ loggedOut: boolean }>('/api/auth/logout', { method: 'POST' });
}
